import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const PoolTargetAudiance = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="pool-target-audiance"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 60 60"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="none"
    >
      <path
        d="M55.959 46.7589C53.3485 44.4137 49.1159 44.4137 46.5054 46.7589L46.4849 46.7773L46.4645 46.7957C43.854 49.1409 39.6214 49.1409 37.0109 46.7957L36.9905 46.7773L36.97 46.7589C34.3595 44.4137 30.1269 44.4137 27.5164 46.7589L27.496 46.7773L27.4756 46.7957C24.8651 49.1409 20.6325 49.1409 18.022 46.7957L18.0015 46.7773L17.9811 46.7589C15.3706 44.4137 11.138 44.4137 8.52749 46.7589L8.50704 46.7773L8.48619 46.7958C7.76008 47.4481 6.90732 47.9158 6 48.2053V56H56V46.7958L55.959 46.7589Z"
        fill={fill}
      />
      <path
        d="M55.959 46.7589C53.3485 44.4137 49.1159 44.4137 46.5054 46.7589L46.4849 46.7773L46.4645 46.7957C43.854 49.1409 39.6214 49.1409 37.0109 46.7957L36.9905 46.7773L36.97 46.7589C34.3595 44.4137 30.1269 44.4137 27.5164 46.7589L27.496 46.7773L27.4756 46.7957C24.8651 49.1409 20.6325 49.1409 18.022 46.7957L18.0015 46.7773L17.9811 46.7589C15.3706 44.4137 11.138 44.4137 8.52749 46.7589L8.50704 46.7773L8.48619 46.7958C7.76008 47.4481 6.90732 47.9158 6 48.2053V56H56V46.7958L55.959 46.7589Z"
        fill={fill}
      />
      <circle cx="21" cy="25" r="4" fill={fill} />
      <circle r="3" transform="matrix(-1 0 0 1 45 28)" fill={fill} />
      <line
        x1="9.82843"
        y1="25.2266"
        x2="17.0249"
        y2="32.4231"
        strokeWidth="4"
        strokeLinecap="round"
        stroke={stroke}
        fill={fill}
      />
      <line
        x1="1.5"
        y1="-1.5"
        x2="9.63937"
        y2="-1.5"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 56 28.2896)"
        strokeWidth="3"
        strokeLinecap="round"
        fill={fill}
        stroke={stroke}
      />
      <circle cx="21" cy="25" r="4" fill={fill} />
      <circle r="3" transform="matrix(-1 0 0 1 45 28)" fill={fill} />
      <path d="M15 30H27V42.5C25 44 23 44.5 21 44C19 43.5 19 42 15 42V30Z" fill={fill} />
      <path
        d="M50 32H40V42.6916C41.6667 43.8546 43.5 44 45 42.8546C46.5 41.7093 46.6667 41.304 50 41.304V32Z"
        fill={fill}
      />
      <line
        x1="2"
        y1="-2"
        x2="12.1774"
        y2="-2"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 35 25.2266)"
        strokeWidth="4"
        strokeLinecap="round"
        fill={fill}
        stroke={stroke}
      />
      <line
        x1="36.1213"
        y1="28.2896"
        x2="41.8767"
        y2="34.045"
        strokeWidth="3"
        strokeLinecap="round"
        stroke={stroke}
        fill={fill}
      />
      <path
        d="M36 27.5C36 24.5 37.8 18.5 45 18.5C52.2 18.5 54 24.5 54 27.5"
        stroke="#A0DBE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M10 24C10 20.3333 12.2 13 21 13C29.8 13 32 20.3333 32 24"
        stroke="#A0DBE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
/* eslint-enable max-len */

PoolTargetAudiance.defaultProps = {
  className: null,
};

PoolTargetAudiance.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default PoolTargetAudiance;
